import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteFieldsRequest, DeleteFieldsResponse, DuplicateFieldRequest, DuplicateFieldResponse, GetFieldRequest, GetFieldResponse, GetFieldSelectorRequest, GetFieldSelectorResponse, GetFieldTypeRequest, GetFieldTypeResponse, GetFieldUuidRequest, GetFieldUuidResponse, GetFieldWithChildrenRequest, GetFieldWithChildrenResponse, PatchFieldRequest, PatchFieldResponse, PostFieldRequest, PostFieldResponse } from './types/TFieldServices';

const URL_Prefix = '/field';

export const fieldService = createApi({
    reducerPath: 'fieldService',
    baseQuery: getBaseQuery,
    tagTypes: ['Field'],
    endpoints: (builder) => ({
        getField: builder.query<GetFieldResponse, GetFieldRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postField: builder.mutation<PostFieldResponse, PostFieldRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Field'],
        }),
        patchField: builder.mutation<PatchFieldResponse, PatchFieldRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Field'],
        }),
        getFieldUuid: builder.query<GetFieldUuidResponse, GetFieldUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
        }),
        getFieldType: builder.query<GetFieldTypeResponse, GetFieldTypeRequest>({
            query: (params) => ({
                url: '/field_type/selector/',
                method: 'GET',
                params: params,
            }),
        }),
        duplicateField: builder.mutation<DuplicateFieldResponse, DuplicateFieldRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/duplicate/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Field'],
        }),
        getFieldSelector: builder.query<GetFieldSelectorResponse, GetFieldSelectorRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
                params: params,
            }),
            providesTags: ['Field'],
        }),
        deleteField: builder.mutation<DeleteFieldsResponse, DeleteFieldsRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/cascade/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Field'],
        }),
        getFieldWithChildren: builder.query<GetFieldWithChildrenResponse, GetFieldWithChildrenRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/with-children/`,
                method: 'GET',
                params: params,
            }),
        }),

    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetFieldQuery,
    useLazyGetFieldQuery,
    usePostFieldMutation,
    useGetFieldUuidQuery,
    useLazyGetFieldUuidQuery,
    useGetFieldTypeQuery,
    useLazyGetFieldTypeQuery,
    usePatchFieldMutation,
    useDuplicateFieldMutation,
    useGetFieldSelectorQuery,
    useLazyGetFieldSelectorQuery,
    useDeleteFieldMutation,
    useGetFieldWithChildrenQuery,
    useLazyGetFieldWithChildrenQuery
} = fieldService;